import { CONDITION_CARDS } from "../../data/content";

/** Step progress indicator (dots + connecting lines) */
export function StepIndicator({ step, total = 3 }) {
  return (
    <div className="mt-8 flex items-center gap-3">
      {Array.from({ length: total }, (_, i) => i + 1).map((n) => (
        <div key={n} className="flex-1 flex items-center gap-3">
          <div className={`w-8 h-8 rounded-full grid place-content-center text-sm ${step >= n ? "bg-brand-blue text-white" : "bg-brand-cream text-brand-ink2"}`}>
            {n}
          </div>
          {n < total && <div className={`h-[2px] flex-1 ${step > n ? "bg-brand-blue" : "bg-brand-cream"}`} />}
        </div>
      ))}
    </div>
  );
}

/** Step 1 — reason for visit */
export function StepReason({ value, onChange }) {
  return (
    <div>
      <h2 className="font-heading text-2xl text-brand-ink">Reason for visit</h2>
      <div className="mt-4 grid grid-cols-2 md:grid-cols-3 gap-3">
        {CONDITION_CARDS.map((c) => (
          <button
            key={c.slug}
            onClick={() => onChange(c.slug)}
            data-testid={`book-reason-${c.slug}`}
            className={`text-left rounded-xl border p-4 hover:border-brand-blue ${value === c.slug ? "border-brand-blue bg-brand-cream" : "border-black/10"}`}
          >
            <div className="font-medium text-brand-ink text-sm">{c.title}</div>
            <div className="text-xs text-brand-ink2 mt-1">{c.short}</div>
          </button>
        ))}
      </div>
    </div>
  );
}

/** Step 2 — preferred date & time */
export function StepDateTime({ form, set }) {
  return (
    <div>
      <h2 className="font-heading text-2xl text-brand-ink">Preferred date & time</h2>
      <div className="grid sm:grid-cols-2 gap-3 mt-4">
        <input
          type="date"
          value={form.preferred_date}
          onChange={(e) => set("preferred_date", e.target.value)}
          data-testid="book-date"
          className="rounded-xl border border-black/10 px-4 py-3 bg-white"
        />
        <select
          value={form.preferred_time}
          onChange={(e) => set("preferred_time", e.target.value)}
          data-testid="book-time"
          className="rounded-xl border border-black/10 px-4 py-3 bg-white"
        >
          <option value="">Preferred time</option>
          {["Morning (9–12)", "Afternoon (12–4)", "Evening (4–8)"].map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>
    </div>
  );
}

/** Step 3 — contact details */
export function StepContact({ form, set }) {
  return (
    <div>
      <h2 className="font-heading text-2xl text-brand-ink">Your details</h2>
      <div className="grid sm:grid-cols-2 gap-3 mt-4">
        <input
          placeholder="Your name"
          value={form.name}
          onChange={(e) => set("name", e.target.value)}
          data-testid="book-name"
          className="rounded-xl border border-black/10 px-4 py-3 bg-white"
        />
        <input
          placeholder="Mobile number"
          value={form.phone}
          onChange={(e) => set("phone", e.target.value)}
          data-testid="book-phone"
          className="rounded-xl border border-black/10 px-4 py-3 bg-white"
        />
        <input
          placeholder="Email (optional)"
          value={form.email}
          onChange={(e) => set("email", e.target.value)}
          className="rounded-xl border border-black/10 px-4 py-3 bg-white sm:col-span-2"
        />
        <textarea
          placeholder="Anything else we should know? (optional)"
          value={form.message}
          onChange={(e) => set("message", e.target.value)}
          className="rounded-xl border border-black/10 px-4 py-3 bg-white sm:col-span-2 min-h-[80px]"
        />
      </div>
    </div>
  );
}
